<template>
  <div class="layout-product-gallery">
    <div class="relative mb-2 aspect-image">
      <transition v-if="!rotationOpened && !isMobile" enter-active-class="animated fadeIn">
        <div class="cursor-pointer abs" @click="openModal">
          <img v-if="currentSlide.src && !currentSlide.url && currentIndex!==0" :src="currentSlide.src" class="object-contain abs" :alt="toLowerCase(title) + '_' + currentIndex" :title="title + '_' + currentIndex" :key="currentIndex" />
          <img v-else-if="currentSlide.src && !currentSlide.url" :src="currentSlide.src" class="object-contain abs" :alt="toLowerCase(title)" :title="title" :key="currentIndex" />
          <!-- :src="currentSlide.youtube" -->
          <iframe
              v-else-if="currentSlide.url"
              class="abs"
              width="560"
              height="315"
              :src="currentSlide.url"
              title="video player 1"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
          ></iframe>
        </div>
      </transition>
      <div
          ref="mobileEmbla"
          class="relative overflow-hidden mobile-embla"
          v-show="!rotationOpened"
          v-else-if="isMobile"
      >
        <div class="flex">
          <div
              class="relative flex-grow-0 flex-shrink-0 min-w-0 flex-basis-100"
              v-for="(image, index) in data"
              :key="index"
          >
            <div class="relative flex items-center justify-center aspect-image" @click="openModal">
              <img v-if="image.src && !image.url" :src="image.src" class="object-contain abs" :alt="'prev' + image.name + index" :title="'prev' + image.name + index" :key="currentIndex" />
              <div class="abs" v-else-if="image.url">
                <!-- :src="image.youtube" -->
                <iframe
                    v-if="index === currentIndex"
                    class="pointer-events-none abs"
                    width="560"
                    height="315"
                    :src="image.url"
                    title="video player 2"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ui-3d-viewer v-if="rotationOpened" :speed="1" autosort :images="rotation"></ui-3d-viewer>
      <!--  -->
      <div v-if="!rotationOpened" class="items-center justify-between hidden pointer-events-none sm:flex arrows abs">
        <div
            @click="prevImage()"
            class="flex items-center justify-center -ml-6 bg-white rounded-full shadow-md cursor-pointer pointer-events-auto w-14 aspect-square"
        >
          <IconChevronLeft></IconChevronLeft>
        </div>
        <div
            @click="nextImage()"
            class="flex items-center justify-center -mr-6 bg-white rounded-full shadow-md cursor-pointer pointer-events-auto w-14 aspect-square"
        >
          <IconChevronRight></IconChevronRight>
        </div>
      </div>
      <!--  -->
      <div class="flex items-end justify-end gap-1 p-5 pointer-events-none abs">
        <div
            v-for="(dot, index) in data"
            :key="index"
            class="w-1 h-1 duration-200 bg-gray-300 rounded"
            :class="[
            {
              'opacity-100': currentIndex === index
            },
            {
              'opacity-30': currentIndex !== index
            }
          ]"
        ></div>
      </div>
      <!--  -->
      <div class="p-2 sm:p-5 pointer-events-none abs grid grid-cols-[auto,auto] justify-between">
        <div v-if="rotation && rotation.length>0">
          <div
              @click="rotationOpened = !rotationOpened"
              class="inline-flex items-center h-10 gap-2 px-4 text-sm font-medium duration-200 border border-solid rounded-full cursor-pointer pointer-events-auto border-white/10"
              :class="[
              {
                'text-white bg-black/20 backdrop-blur-md hover:bg-black/40': !rotationOpened
              },
              {
                'bg-gray-50': rotationOpened
              }
            ]"
          >
            <IconCube v-if="!rotationOpened" class="w-auto h-5"></IconCube>
            <IconClose v-else class="w-auto h-2"></IconClose>
            <span v-if="!rotationOpened">Посмотреть 3D</span>
            <span v-else>Закрыть 3D</span>
          </div>
        </div>
        <div v-else></div>
        <!-- елси есть презентация -->
        <div
          @click="$bus.$emit('videoPresent')"
          class="inline-flex items-center h-10 gap-2 px-4 text-sm font-medium text-white duration-200 border border-solid rounded-full cursor-pointer pointer-events-auto border-white/10 bg-black/20 backdrop-blur-md hover:bg-black/40"
        >
          <IconVideo class="w-auto h-5"></IconVideo>
          <span>Видеопрезентация</span>
        </div>
        <!-- если нет -->
        <!-- <div></div> -->
        <!--  -->
        <div v-if="!rotationOpened && videos.length" class="flex items-start justify-start gap-1 mt-auto sm:flex-col">
          <div
              v-for="(video, index) in videos"
              :key="index"
              @click="$bus.$emit('video', video)"
              class="inline-flex items-center h-10 gap-2 px-4 text-sm font-medium text-white duration-200 border-2 border-solid rounded-full cursor-pointer pointer-events-auto backdrop-blur-md bg-black/20 hover:bg-black/40"
          >
            <IconPlay class="w-auto h-3"></IconPlay>
            <span class="hidden sm:inline">{{ video.name }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="hidden sm:block">
      <div class="overflow-hidden embla" ref="embla">
        <div class="flex embla__container">
          <div
              class="min-w-0 mr-2 embla__slide flex-basis-40"
              v-for="(image, index) in data"
              :key="index"
              @click="scrollToSlide(index)"
          >
            <div class="relative flex items-center justify-center aspect-image">
              <img v-if="image.src" :src="image.src" class="object-contain abs" :alt="image.name + index" :title="image.name + index" />
              <img src="/images/youtube.png" class="w-10 h-auto abs" style="z-index:1; top:50%; left:50%;" v-if="image.url" :alt="image.name + index" :title="image.name + index" />
              <div
                  class="duration-300 abs"
                  :class="[
                  {
                    'border-[6px] border-solid border-white/40': currentIndex === index
                  }
                ]"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal -->
    <transition leave-active-class="animated fadeOut">
      <div class="abs !fixed z-[999] flex" v-show="modalOpened">
        <div class="bg-black sm:bg-black/40 abs animated fadeIn" @click="closeModal"></div>
        <div class="w-full sm:w-[96vw] sm:m-auto animated zoomIn relative">
          <div class="h-full overflow-hidden embla" ref="modalEmbla">
            <div class="flex h-full embla__container">
              <div
                  class="flex items-center h-full min-w-0 mr-2 embla__slide flex-basis-100"
                  v-for="(image, index) in data"
                  :key="index"
              >
                <div class="relative flex items-center justify-center w-full aspect-image">
                  <img
                      v-if="image.src"
                      :src="image.src"
                      class="object-contain select-none abs"
                      :alt="image.name + index" :title="image.name + index"
                      :key="currentIndex"
                  />
                  <div class="abs" v-else-if="image.url">
                    <!--  :src="image.youtube" -->
                    <iframe
                        v-if="index === currentIndex && modalOpened"
                        class="abs"
                        width="560"
                        height="315"
                        :src="image.url"
                        title="YouTube video player 3"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--  -->
          <div class="items-center justify-between hidden pointer-events-none sm:flex arrows abs">
            <div
                @click="prevImage(true)"
                class="flex items-center justify-center w-10 ml-2 text-white rounded-full shadow-md cursor-pointer pointer-events-auto bg-black/40 backdrop-blur-md aspect-square"
            >
              <IconChevronLeft></IconChevronLeft>
            </div>
            <div
                @click="nextImage(true)"
                class="flex items-center justify-center w-10 mr-2 text-white rounded-full shadow-md cursor-pointer pointer-events-auto bg-black/40 backdrop-blur-md aspect-square"
            >
              <IconChevronRight></IconChevronRight>
            </div>
          </div>
          <!--  -->
          <div class="absolute bottom-0 flex justify-center w-full gap-1 p-3 pointer-events-none">
            <div class="flex gap-1 px-3 py-2 rounded-full bg-black/40 backdrop-blur-md">
              <div
                  v-for="(dot, index) in data"
                  :key="index"
                  class="w-1 h-1 duration-200 bg-gray-300 rounded"
                  :class="[
                  {
                    'opacity-100': currentIndex === index
                  },
                  {
                    'opacity-30': currentIndex !== index
                  }
                ]"
              ></div>
            </div>
          </div>
        </div>
        <!--  -->
        <div
            class="absolute top-0 right-0 z-10 flex items-center justify-center w-10 h-10 m-5 text-white rounded-full cursor-pointer bg-black/50 backdrop-blur-md"
            @click="closeModal"
        >
          <IconClose></IconClose>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import EmblaCarousel from 'embla-carousel'
export default {
  props: {
    data: {
      type: Array,
      default: () => {
        return []
      }
    },
    title: '',
    rotation: {
      type: Array,
      default: () => {
        return []
      }
    },
    videos: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      currentIndex: 0,
      rotationOpened: false,
      embla: null,
      emblaModal: null,
      isMobile: false,
      modalOpened: false
    }
  },
  computed: {
    currentSlide() {
      let vidos = this.data[this.currentIndex];
      if(vidos.type=="rutube"){
        vidos.url = 'https://rutube.ru/play/embed/'+vidos.id;
      }else if( vidos.type && vidos.id ){
        vidos.url = 'https://www.youtube.com/embed/'+vidos.id;
      }
      return vidos
    }
  },
  mounted() {
    this.isMobile = window.innerWidth < 768
    this.initCarousel()

    // модалка
    this.initModalCarousel()
  },
  methods: {
    openInModal() {
      this.openVideoPlayer(this.data[this.currentIndex])
    },
    closeModal() {
      this.modalOpened = false
    },
    openModal() {
      this.modalOpened = true
      this.emblaModal.scrollTo(this.currentIndex)
    },
    openVideoPlayer(video) {
      //const videoId = videoLink.split('/').pop();
      const vidos = {id:video.id,type:video.type};
      this.$bus.$emit('video', vidos);
    },
    initModalCarousel() {
      const modalEmblaNode = this.$refs.modalEmbla
      setTimeout(() => {
        if (!modalEmblaNode) return
        this.emblaModal = EmblaCarousel(modalEmblaNode, {
          align: 'center',
          containScroll: false,
          loop: true
        })
        this.emblaModal.on('select', (...value) => {
          this.currentIndex = this.emblaModal.selectedScrollSnap()
          this.embla.scrollTo(this.currentIndex)
        })
      }, 100)
    },
    initCarousel() {
      setTimeout(() => {
        const emblaNode = this.isMobile ? this.$refs.mobileEmbla : this.$refs.embla
        if (!emblaNode) return
        this.embla = EmblaCarousel(emblaNode, {
          align: 'center',
          containScroll: false,
          loop: true
        })
        this.embla.on('select', (...value) => {
          this.currentIndex = this.embla.selectedScrollSnap()
        })
      }, 500)
    },
    scrollToSlide(index) {
      this.embla.scrollTo(index)
    },
    nextImage(inModal = false) {
      if (inModal) {
        this.emblaModal.scrollNext()
      } else {
        this.embla.scrollNext()
      }
    },
    prevImage(inModal = false) {
      if (inModal) {
        this.emblaModal.scrollPrev()
      } else {
        this.embla.scrollPrev()
      }
    },
    toLowerCase(str){
      return str.toLowerCase();
    }
  },
  components: {
    'ui-3d-viewer': () => import('@/components/ui/ui-3d-viewer'),
    IconCube: () => import('@/components/icon/icon-cube'),
    IconClose: () => import('@/components/icon/icon-close'),
    IconPlay: () => import('@/components/icon/icon-play'),
    IconVideo: () => import('@/components/icon/icon-video'),
    IconChevronLeft: () => import('@/components/icon/icon-chevron-left'),
    IconChevronRight: () => import('@/components/icon/icon-chevron-right')
  }
}
</script>

<style lang="scss" scoped>
.disabled-scrollbar::-webkit-scrollbar {
  display: none;
}
</style>
